import React from 'react'; // eslint-disable-line
import { withStyles, Grid, Typography, Paper } from '@material-ui/core';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { LabeledValue } from '../../../../../controls/labeled-value';
import { connect } from 'react-redux';
import { State } from '../../../../../redux/root-reducer';
import { FormDetails, getFormDetails } from '../form-details-reducer';
import { getDisplayDate } from '../../../../../shared-functions';
import { OpenModal, openModalAction } from '../../../../../form-modal/actions';
import { UpdateFormDetails, updateFormDetailsAction } from '../actions/update-form-details';

interface BaseProps {
    formDetails?: FormDetails;
    updateFormDetails?: UpdateFormDetails;
    disableEditButton?: boolean;
}
interface Props extends BaseProps, StyledComponent {
    readonly openModal: OpenModal;
}

const medicalAidDetailsView: React.FunctionComponent<Props> = ({ classes, formDetails }: Props) => {
    const medicalAidDetails = formDetails?.lifeAssured?.medicalAidDetails;
    const hasMedicalAid = medicalAidDetails?.doesTheLifeAssuredHaveAMedicalAid === 'Yes';
    const isOtherMedicalAidSelected = medicalAidDetails?.medicalAidName?.toLowerCase() === 'other';

    return (
        <React.Fragment>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={10} alignItems="center">
                    <Typography style={{ padding: 10 }} className={classes.heading} variant="body1">
                        Medical Aid Details
                    </Typography>
                </Grid>
            </Grid>
            <Paper className={classes.paper}>
                <Grid container justify="flex-start">
                    <Grid item xs={12} container justify="flex-start">
                        <Grid item xs={4} lg={hasMedicalAid ? 3 : 12}>
                            <LabeledValue
                                label="Does the life assured have medical aid?"
                                value={medicalAidDetails?.doesTheLifeAssuredHaveAMedicalAid}
                            />
                        </Grid>
                        {hasMedicalAid && (
                            <>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Medical aid name"
                                        value={medicalAidDetails?.medicalAidName}
                                    />
                                </Grid>
                                {isOtherMedicalAidSelected && (
                                    <Grid item xs={4} lg={3}>
                                        <LabeledValue
                                            label="Medical aid name"
                                            value={medicalAidDetails?.otherMedicalAidName}
                                        />
                                    </Grid>
                                )}
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Medical aid number"
                                        value={medicalAidDetails?.medicalAidNumber}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Date joined"
                                        value={getDisplayDate(medicalAidDetails?.dateJoined)}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Is the life assured the main member on the medical aid"
                                        value={
                                            medicalAidDetails?.isLifeAssuredMainMemberOnTheMedicalAid
                                        }
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Main member title"
                                        value={medicalAidDetails?.mainMembersTitle}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Main member first names"
                                        value={medicalAidDetails?.mainMembersFirstName}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Main member surname"
                                        value={medicalAidDetails?.mainMembersSurname}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Main member ID Number / Number Passport"
                                        value={
                                            medicalAidDetails?.mainMembersIdNumberOrPassportNumber
                                        }
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails || getFormDetails(state),
    disableEditButton: ownProps.disableEditButton || false,
});

const mapDispatchToProps = {
    openModal: openModalAction,
    updateFormDetails: updateFormDetailsAction,
};

export const MedicalAidDetailsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(medicalAidDetailsView));
